module.exports = "/img/about-bg.466b7443.png";